export default function setGooeyTextMorphing() {
  const sections = document.querySelectorAll('[data-gooey-text-morphing]');

  if (!sections.length) {
    return;
  }

  sections.forEach((section) => {
    const texts = [
      'INPYX',
      'Agência de Performance',
      'e',
      'E-Commerce' 
    ];
    const text1 = section.querySelector('.gooey-text-1');
    const text2 = section.querySelector('.gooey-text-2');

    if (!text1 || !text2) {
      return;
    }

    let textIndex = texts.length - 1;
    let time = Date.now();
    let morph = 0;
    let cooldown = 0.25;
    const morphTime = 1;
    const cooldownTime = 0.25;
    let animationFrame = 0;

    const setMorph = (fraction) => {
      if (!text1 || !text2) {
        return;
      }

      const blurValue = Math.min(8 / fraction - 8, 100);
      text2.style.filter = `blur(${blurValue}px)`;
      text2.style.opacity = `${Math.pow(fraction, 0.4) * 100}%`;

      fraction = 1 - fraction;
      const blurValue1 = Math.min(8 / fraction - 8, 100);
      text1.style.filter = `blur(${blurValue1}px)`;
      text1.style.opacity = `${Math.pow(fraction, 0.4) * 100}%`;
    };

    const doCooldown = () => {
      morph = 0;
      if (!text1 || !text2) {
        return;
      }
      text2.style.filter = '';
      text2.style.opacity = '100%';
      text1.style.filter = '';
      text1.style.opacity = '0%';
    };

    const animate = () => {
      const newTime = Date.now();
      const dt = (newTime - time) / 1000;
      time = newTime;

      const shouldIncrementIndex = cooldown > 0;
      cooldown -= dt;

      if (cooldown <= 0) {
        if (shouldIncrementIndex) {
          textIndex = (textIndex + 1) % texts.length;
          if (text1 && text2) {
            text1.textContent = texts[textIndex % texts.length];
            text2.textContent = texts[(textIndex + 1) % texts.length];
          }
        }

        morph += dt;
        let fraction = morph / morphTime;

        if (fraction > 1) {
          cooldown = cooldownTime;
          fraction = 1;
        }

        setMorph(fraction);
      } else {
        doCooldown();
      }

      animationFrame = window.requestAnimationFrame(animate);
    };

    if (text1 && text2) {
      text1.textContent = texts[textIndex % texts.length];
      text2.textContent = texts[(textIndex + 1) % texts.length];
      text2.style.opacity = '0%';
    }

    animationFrame = window.requestAnimationFrame(animate);

    section.addEventListener('disconnected', () => {
      window.cancelAnimationFrame(animationFrame);
    });
  });
}
